<div class="breadcrumb">
  @for (item of breadcrumbItems; track item.label; let last = $last) {
    <div class="breadcrumb-item">
      @if (!last) {
        <a [routerLink]="item.link" queryParamsHandling="preserve" class="breadcrumb-link">{{ item.label }}</a>
        <span class="breadcrumb-separator">/</span>
      } @else {
        <div class="breadcrumb-current">{{ item.label }}</div>
      }
    </div>
  }
</div>
